import React, { useEffect, useState } from 'react';
import InfinityLoader from '../dropdownSearch/infinityLoader';
import API from '../../services/api';
import utils from '../../utils';

const IntegrationSelector = ({ onSelect, filterObject, selected, disabled }) => {
  const [currentItems, setCurrentItems] = useState([]);
  const [currentFilter, setCurrentFilter] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadMoreItems();
    }
  }, [isOpen]);

  const loadMoreItems = (nextPageToken = '', searchingBy = '') => {
    const query = encodeURI(`displayName ILIKE "%${searchingBy}%" OR id ILIKE "%${searchingBy}%"`);
    const filter = searchingBy !== '' ? query : '';

    if (filter !== currentFilter) {
      setCurrentItems([]);
    }

    return API.getIntegrations(nextPageToken, filter).then(results => {
      const fetchedData = results.integrations.map(result => ({
        label: `${result.vendor}`.charAt(0).toUpperCase() + `${result.vendor}`.slice(1).toLowerCase(),
        value: `"${result.vendor}"`,
        data: result
      }));

      // Reset list when filter changes
      if (filter !== currentFilter) {
        setCurrentFilter(filter);
        setCurrentItems(fetchedData);
      } else {
        const newIntegrations = utils.mergeArraysByField(fetchedData, currentItems, 'value');
        setCurrentItems(newIntegrations);
      }

      return results.nextPageToken;
    });
  };

  return (
    <div className="integration-selector">
      <InfinityLoader
        title={'Search Integration'}
        leftAlign
        selected={selected}
        disabled={disabled}
        onSelect={selectedValue => {
          const integration = currentItems.filter(item => item.value === selectedValue);
          return onSelect(integration[0], { ...filterObject, options: currentItems });
        }}
        onLoading={loadMoreItems}
        onOpenChange={setIsOpen}
        totalSize={9999}
        options={currentItems}
      />
    </div>
  );
};

export default IntegrationSelector;
